
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/company-history",
      function () {
        return require("private-next-pages/about-us/company-history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/company-history"])
      });
    }
  